<router-outlet></router-outlet>
<app-bootstrap-size-indicator *ngIf="!isProduction"></app-bootstrap-size-indicator>